import {
  trackProductError,
  trackProductEvent,
  type ProductBaseProperties,
} from "./product";

export const RITUAL_BATHS_FLOW = "ritual_baths";

export type RitualBathsEventName =
  | "ritual_bath_tab_changed"
  | "ritual_bath_filter_changed"
  | "ritual_bath_selected"
  | "ritual_bath_manage_categories_clicked"
  | "ritual_bath_categories_viewed"
  | "ritual_bath_create_submit_attempt"
  | "ritual_bath_created"
  | "ritual_bath_create_error"
  | "ritual_bath_update_submit_attempt"
  | "ritual_bath_updated"
  | "ritual_bath_update_error"
  | "ritual_bath_deleted"
  | "ritual_bath_delete_error"
  | "ritual_bath_copied"
  | "ritual_bath_copy_error"
  | "ritual_bath_schedule_opened"
  | "ritual_bath_schedule_submit_attempt"
  | "ritual_bath_scheduled"
  | "ritual_bath_schedule_error"
  | "ritual_bath_form_chat_started"
  | "ritual_bath_form_chat_field_collected"
  | "ritual_bath_form_chat_completed";

export const trackRitualBathsEvent = (
  event: RitualBathsEventName,
  baseProperties: ProductBaseProperties,
  eventProperties?: Record<string, unknown>,
): void => {
  trackProductEvent(event, baseProperties, eventProperties, RITUAL_BATHS_FLOW);
};

export const trackRitualBathsError = (
  event: RitualBathsEventName,
  baseProperties: Omit<ProductBaseProperties, "success" | "errorCode">,
  error: unknown,
  eventProperties?: Record<string, unknown>,
): void => {
  trackProductError(
    event,
    baseProperties,
    error,
    eventProperties,
    RITUAL_BATHS_FLOW,
  );
};
